import React from 'react';
import { CATALOG } from '../../constants/catalog';
import { priceOf, ILS } from '../../utils/salesUtils';

export default function SaleLineItem({ item, index, onQtyChange, onRemove, readOnly }) {
  const unitPrice = priceOf(item);
  const lineTotal = unitPrice * (item.qty || 1);
  const catDef = CATALOG[item.cat];
  const catLabel = catDef?.label || 'Ítem';
  const catIcon = catDef?.icon || '✏️';

  return (
    <div className="pos-line-item">
      <div className="pos-li-top">
        <div className="pos-li-icon">{catIcon}</div>
        <div className="pos-li-body">
          <span className="pos-cat-pill">
            {catLabel}{item.sized ? ` · ${item.size}` : ''}
          </span>
          <div className="pos-li-name">{item.name}</div>
          {item.unit && <div className="pos-li-sub">{item.unit}</div>}
        </div>
        {!readOnly && (
          <button
            className="pos-li-del"
            onClick={() => onRemove(index)}
            aria-label="Eliminar"
          >
            🗑
          </button>
        )}
      </div>

      <div className="pos-li-bottom">
        {readOnly ? (
          <span className="pos-unit-price">{item.qty || 1} × {ILS(unitPrice)}</span>
        ) : (
          <>
            <div className="pos-qty">
              <button
                className="pos-qty-btn"
                onClick={() => onQtyChange(index, -1)}
                disabled={(item.qty || 1) <= 1}
              >
                −
              </button>
              <span className="pos-qty-n">{item.qty || 1}</span>
              <button
                className="pos-qty-btn"
                onClick={() => onQtyChange(index, +1)}
              >
                +
              </button>
            </div>
            <span className="pos-unit-price">× {ILS(unitPrice)} {item.unit}</span>
          </>
        )}
        <span className="pos-line-total">{ILS(lineTotal)}</span>
      </div>
    </div>
  );
}
